<script>
  import { getSavedData } from '../utilities/helper.js';
  export let i18n, savedData;
</script>

<pre>
  <code contenteditable>{getSavedData(savedData)}</code>
</pre>
